module.exports = __webpack_public_path__ + "img/moneyman.e93550b4.svg";